export default __webpack_public_path__ + "static/coniferous-2ea4d6f5978753114daf557ceb6258d7.png";